import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceLocator } from './service-locator/service-locator';
import { NewHomepageComponent } from './new-homepage/new-homepage.component';
import { NewSubscriptionPageComponent } from './new-subscription-page/new-subscription-page.component';
import { RouterModule, Routes } from '@angular/router';
import { CustomFirestoreService, DeviceDetectionService, StripePaymentSelectionService } from '@spout/global-web/data-access';
import { CheckoutComponent } from './checkout/checkout.component';
import { NewCheckoutComponent } from './new-checkout/new-checkout.component';
import { NewDownloadComponent } from './new-download/new-download.component';
import { DownloadSpoutModule } from "../global-web/ui/src/lib/components/download-spout/download-spout.module";

import { LetModule, PushModule } from '@ngrx/component';
import { AddonStorageModuleModule } from '@spout/global-web/feature-page-subscribe';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
const routes: Routes = [
  {
    path: '',
    component: NewHomepageComponent,
  },
  {
    path: 'home',
    component: NewHomepageComponent,
  },
  {
    path: 'subscribe',
    component: NewSubscriptionPageComponent,
  },
  {
    path: 'checkout',
    component: NewCheckoutComponent,
  },
  {
    path: 'downloads',
    component: NewDownloadComponent,
  },
  {
    path: 'download',
    component: NewDownloadComponent,
  }
];

@NgModule({
  declarations: [NewHomepageComponent, NewSubscriptionPageComponent, CheckoutComponent, NewCheckoutComponent, NewDownloadComponent],
  exports: [RouterModule],
  providers: [ServiceLocator,
    StripePaymentSelectionService,
    DeviceDetectionService,
    CustomFirestoreService,
  ],
  imports: [RouterModule.forChild(routes),
    DownloadSpoutModule,
    LetModule,
    PushModule,
    FormsModule ,
    AddonStorageModuleModule,
    CommonModule,
    MatButtonModule,
    MatIconModule]
})
export class MarketingModule { }
